/* ==========================================================================
   WeScaled — standard-actions.js

   Shopify's Storefront Renderer injects window.Shopify.actions
   ({ updateCart, openCart, getCart, ... }). The defaults work, but they fall
   back to a full page reload. Overriding them here lets apps and AI shopping
   agents drive this theme's real UI — opening the drawer, refreshing sections —
   instead of bouncing the buyer through a reload.

   Delete this file and the platform defaults quietly take over.
   ========================================================================== */

(function () {
  'use strict';

  function initStandardActions() {
    const actions = window.Shopify && window.Shopify.actions;
    if (!actions) return;

    if (actions.openCart && typeof actions.openCart.configure === 'function') {
      actions.openCart.configure({
        async handler(defaultHandler) {
          const drawer = document.getElementById('CartDrawer');
          if (drawer && typeof drawer.open === 'function') {
            drawer.open();
            return;
          }
          return defaultHandler();
        },
      });
    }

    if (actions.updateCart && typeof actions.updateCart.configure === 'function') {
      actions.updateCart.configure({
        eventTarget: () => document,
        async handler(defaultHandler) {
          const result = await defaultHandler();

          try {
            // The mutation already landed server-side; just pull fresh HTML for
            // every cart surface currently mounted.
            const surfaces = Array.from(document.querySelectorAll('cart-items'));
            await Promise.all(surfaces.map((surface) => surface.refresh()));

            const cart = await fetch(`${window.theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } })
              .then((r) => (r.ok ? r.json() : null))
              .catch(() => null);

            if (cart && window.WS && window.WS.cart) {
              window.WS.cart.updateCartCount(cart.item_count);
              window.WS.publish('cart:update', { source: 'standard-action', cart });
            }
          } catch (error) {
            console.error('[WeScaled] Cart refresh after a standard action failed; reloading.', error);
            window.location.reload();
          }

          return result;
        },
      });
    }
  }

  if (window.Shopify && window.Shopify.actions) {
    initStandardActions();
  } else {
    document.addEventListener('DOMContentLoaded', initStandardActions, { once: true });
  }
})();
